module.exports = __webpack_public_path__ + "img/2.6bcadbfa.png";